module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "backcolor1"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("To Albert,"), _c('br'), _vm._v("With all my love,"), _c('br'), _vm._v("—Laurie")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationa"
  }, [_vm._v("For little Juliette, my fashion princess"), _c('br'), _vm._v("and best shopping buddy"), _c('br'), _vm._v("—J.K.")]), _vm._v(" "), _c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb4c34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 60
// module chunks = 0